import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 566141F9-DB64-4210-8384-EB77CFA9E8A0
 * name power-on
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-on.svg
 * tags
 */
export const PowerOnIcon = createSvgIcon(<><path d="M11,3H13V21H11V3Z" /></>, 'PowerOnIcon');
export default PowerOnIcon